(() => {
    'use strict';

    function lightboxItemDir($uibModal) {

        var dir = {
            restrict: 'E',
            replace: true,
            modalTemplate: `
                <div class="modal-body">
                    <button class="btn btn-show-info" ng-if="modal.hasText" ng-click="modal.info = !modal.info" aria-label="toggle image details">
                        <span class="fa fa-question-circle"></span>
                    </button>
                    <button class="btn btn-close" ng-click="modal.dismiss()" aria-label="close">
                        <span class="fa fa-circle-xmark"></span>
                    </button>
                    <img ng-src="{{ modal.src }}" />
                    <div class="lightbox-nav" ng-if="modal.itemCount > 1">
                        <button class="btn" ng-click="modal.next(false)" aria-label="previous"><span class="fa fa-chevron-left"></span></button>
                        <button class="btn" ng-click="modal.next(true)" aria-label="next"><span class="fa fa-chevron-right"></span></button>
                    </div>
                    <div class="lightbox-content" ng-class="{ 'content-in': modal.info, 'has-text' : modal.hasText, 'has-title' : modal.title.length }">
                        <h5 class="lightbox-heading" ng-show="modal.title.length" ng-bind="modal.title"></h5>
                        <div class="lightbox-text" ng-show="modal.summary.length" ng-bind-html="modal.summary"></div>
                      </div>
                </div>`,
            template: `
                <div class="lightbox-item {{ type }}" ng-click="lightbox()">
                    <img class="lightbox-image" ng-src="{{ src }}?width=187.5&height=187.5&mode=crop" alt="" />
                    <div class="lightbox-content">
                        <h6 class="lightbox-heading" ng-bind="title"></h6>
                    </div>
                    <div class="lightbox-text hidden" id="lightbox-text-{{ index }}" ng-bind-html="summary"></div>
                </div>`,
            scope: {
                src: '@',
                title: '@',
                summary: '@',
                index: '@',
                type: '@'
            },
            link: link
        };

        // wires up the click for lightboxing
        function link(scope, element) {

            scope.lightbox = () => {
                var modal = $uibModal.open({
                    template: dir.modalTemplate,
                    controller: 'Usc.Lightbox.Modal.Ctrl',
                    controllerAs: 'modal',
                    windowClass: 'grid-lightbox',
                    resolve: {
                        src: () => scope.src,
                        title: () => scope.title,
                        index: () => scope.index,
                        summary: () => scope.summary,
                        itemCount: () => element[0].parentElement.querySelectorAll('.lightbox-item:not(.lightbox-more)').length,
                        lightboxId: () => element[0].parentElement.dataset.lightboxId
                    }
                });

                modal.opened.then(() => {
                    document.body.classList.add('content-item-modal-open');
                });

                modal.result.then(() => { },
                    () => {
                        document.body.classList.remove('content-item-modal-open');
                    });
            }
        }

        return dir;
    }

    angular.module('Uscapp').directive('lightboxItem', ['$uibModal', lightboxItemDir]);

    // modal controller
    function lightboxModalCtrl($uibModalInstance, $sce, src, title, index, summary, itemCount, lightboxId) {

        index = parseInt(index, 10);

        angular.extend(this, {
            src: src,
            title: title,
            summary: summary,
            itemCount: itemCount,
            hasText: summary.length > 0,

            next: isNext => {

                if (isNext) {
                    index = index + 1 < itemCount ? index + 1 : 0;
                } else {
                    index = index - 1 >= 0 ? index - 1 : itemCount - 1;
                }

                const nextImg = document.querySelector(`[data-lightbox-id="${lightboxId}"] .lightbox-item[index="${index}"]`);

                this.src = nextImg.getAttribute('src');
                this.title = nextImg.getAttribute('title');
                this.summary = nextImg.getAttribute('summary');
                this.hasText = this.summary.length > 0;
            },

            dismiss: () => {
                $uibModalInstance.dismiss();
            }
        });
    }

    angular.module('Uscapp').controller('Usc.Lightbox.Modal.Ctrl', ['$uibModalInstance', '$sce', 'src', 'title', 'index', 'summary', 'itemCount', 'lightboxId', lightboxModalCtrl]);

})();